/*
  <p
    color={color}
    size={size} 
    className={className}
  />
  - - - - - - - - - - - - -
  color -> white / black
  size -> xl / lg / md / sm / xs
  className -> css classes
  - - - - - - - - - - - - -
*/

export default function Para({
  color,
  className,
  desktopSize,
  mobileSize,
  children,
  ...props
}) {
  return (
    <p
      className={`text tc-${color} text--${desktopSize}-d text--${mobileSize} ${className}`}
      {...props}
    >
      {children}
    </p>
  );
}

Para.defaultProps = {
  color: "black",
  desktopSize: "md",
  mobileSize: "sm",
  className: "",
};
